import angular from 'angular';

import component from './experience-dashboard.component';

const ExperienceDashboard = angular
    .module('control-room.experience-promoter.components.experience-dashboard', [])
    .component('crExperienceDashboard', component);

export default ExperienceDashboard;
